module.exports = __webpack_public_path__ + "static/media/infoIcon.9645da3f.png";